import { IMarketArticlesFilterPayload } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Articles/IMarketArticle';
import FilterSection from '@framework/ui/Organisms/Filters/components/FilterSection';
import { AsyncSelect } from '@creditflowresearch/uilib/Select';
import {
  useArticlesFilterContext,
} from '@/creditflowresearch/application/ArticlesAndStats/Articles/Filter/ArticlesFilterContext';
import { IOptionParentIssuer } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Articles/IParent';
import MultiValueParentIssuerList from './MultiValueParentIssuerList';

interface ISidebarDealListProps {
  filterParentName: string,
  filterIssuerName: string,
  sectionId: number | string,
  sectionTitle: string,
  isVisible: boolean,
  onSectionToggle: (activeKey: number | string) => void,
  handleFilterUpdate: (filters: Partial<IMarketArticlesFilterPayload>) => void,
}

const MIN_LENGTH_QUERY = 3;

const SidebarParentIssuerList = ({
  filterParentName,
  filterIssuerName,
  sectionId,
  sectionTitle,
  isVisible,
  onSectionToggle,
  handleFilterUpdate,
}: ISidebarDealListProps) => {
  const { parentIssuer: { selected, setSelected, loadParentIssuer, currentOptions } } = useArticlesFilterContext();

  const onChange = (selectedValues: IOptionParentIssuer[]) => {
    const parents = selectedValues.filter((item) => item.isParent).map((item) => item.id);
    const issuers = selectedValues.filter((item) => !item.isParent).map((item) => item.id);

    handleFilterUpdate({ [filterParentName]: parents, [filterIssuerName]: issuers });
    setSelected(selectedValues);
  };

  return (
    <FilterSection
      sectionId={ sectionId }
      headerComponent={ sectionTitle }
      isVisible={ isVisible }
      onSectionToggle={ onSectionToggle }
    >
      <AsyncSelect
        name="selectParentIssuer"
        placeholder="Select Parent Company or Issuer"
        dataTest="selectParentIssuer"
        value={ selected }
        onChange={ onChange }
        loadOptions={ loadParentIssuer }
        useDebounce={ { minInputLength: MIN_LENGTH_QUERY } }
        defaultOptions={ currentOptions }
        hideSelectedOptions={ false }
        closeMenuOnSelect={ false }
        components={ { MultiValue: MultiValueParentIssuerList } }
        isGrouped
        isMulti
        isNarrow
        isSupportHighlighting={ false }
        filterOption={ () => true }
      />
    </FilterSection>
  );
};

export default SidebarParentIssuerList;
